const defaultQueryConfig = { staleTime: 30000 }

const defaultConfig = { queries: defaultQueryConfig }

export const queryClientConfig = { defaultOptions: defaultConfig }
